import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import './../../style/Vars.css';
import './../../style/MobileStyles.css';

import { ENDPOINTS } from "../Seguridad/Utils/Endpoints";
import { Models } from "../Seguridad/Utils/ModelsSeguridad";
import { getSessionUserId } from "../../utils/SessionUser";

const submoduleIcons = {
  comunicacion: "📣",
  usuario: "👤",
};

const getModuleColor = (id) => {
  const colors = {
    comunicacion: "blue",
    usuario: "violet",
  };
  return colors[id] || "cyan";
};

const INTRANET_SUBMODULES = [
  {
    id: "comunicacion",
    title: "Administrador",
    description: "Gestión de avisos, noticias, encuestas, foros, calendario y documentos.",
    path: "/menu/intranet/comunicacion/dashboard",
  },
  {
    id: "usuario",
    title: "Usuarios",
    description: "Vista de intranet para colaboradores.",
    path: "/menu/intranet/usuario",
  },
];

const endpointRecursos = ENDPOINTS.recursos;
const modeloRecurso = Models.catRecursos;

export default function IntranetPanel() {
  const navigate = useNavigate();

  const [sessionUserId] = useState(() => getSessionUserId());
  const [visibleSubmodules, setVisibleSubmodules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  const handleClick = (path) => {
    navigate(path);
  };

  useEffect(() => {
    async function loadRecursos() {
      try {
        if (!sessionUserId) {
          setErrorMsg(
            "No se pudo identificar al usuario en sesión. No hay paneles disponibles."
          );
          setVisibleSubmodules([]);
          setLoading(false);
          return;
        }

        const url = `${endpointRecursos}/${sessionUserId}/Panel`;
        const res = await axios.get(url);

        const recursos = (res.data || []).map(modeloRecurso);

        const allowedIds = new Set(
          recursos
            .filter(
              (r) =>
                (r.tipo || "").toLowerCase() === "panel" &&
                (r.ruta || "").trim() !== ""
            )
            .map((r) => (r.ruta || "").trim())
        );

        console.log("[IntranetPanel] Recursos permitidos:", allowedIds);

        const filtered = INTRANET_SUBMODULES.filter((m) => allowedIds.has(m.id));

        setVisibleSubmodules(filtered);
        setLoading(false);

        if (!filtered.length) {
          setErrorMsg("No tienes paneles de Intranet asignados en este momento.");
        }
      } catch (err) {
        console.error("[IntranetPanel] Error al cargar recursos:", err);
        setErrorMsg(
          "Ocurrió un problema al cargar tus permisos. Intenta de nuevo más tarde."
        );
        setVisibleSubmodules([]);
        setLoading(false);
      }
    }

    loadRecursos();
  }, [sessionUserId]);

  return (
    <div className="modules-container">
      <h1>Intranet</h1>

      {loading ? (
        <div className="modules-loading">Cargando paneles disponibles...</div>
      ) : errorMsg ? (
        <div className="modules-error">{errorMsg}</div>
      ) : (
        <div className="modules-grid">
          {visibleSubmodules.map((submodule) => (
            <div
              key={submodule.id}
              className={`module-card module-card--${getModuleColor(submodule.id)}`}
              onClick={() => handleClick(submodule.path)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => e.key === "Enter" && handleClick(submodule.path)}
            >
              <div className="module-card__title">{submodule.title}</div>
              <div className="module-card__description">{submodule.description}</div>
              <div className="module-card__icon" aria-hidden="true">
                {submoduleIcons[submodule.id] || "📁"}
              </div>
            </div>
          ))}
        </div>
      )}

      {!loading && !visibleSubmodules.length && !errorMsg && (
        <div className="modules-empty">No hay paneles de Intranet disponibles.</div>
      )}
    </div>
  );
}
